export enum PrintFormatEnum {
  PDF = 'PDF',
  PNG = 'PNG',
  JPG = 'JPG',
}
